import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

// Catches render-time crashes and shows a plain Dutch card instead of a blank
// white screen.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI error boundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-background px-4">
          <Card className="max-w-md p-8 text-center">
            <h1 className="mb-2 text-kop font-semibold text-foreground">
              Er ging iets mis
            </h1>
            <p className="mb-6 text-body text-muted-foreground">
              Er is een onverwachte fout opgetreden. Herlaad de pagina om verder te gaan.
            </p>
            <Button data-testid="error-boundary-reload" onClick={() => window.location.reload()}>
              Pagina herladen
            </Button>
          </Card>
        </div>
      );
    }
    return this.props.children;
  }
}
